import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { ToasterService } from 'angular2-toaster';
import 'rxjs/add/operator/toPromise';

import { ServiceInvoiceModel } from '../model/index';

@Injectable()
export class ServiceInvoiceService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private serviceInvoiceUrl = 'api/serviceInvoice';  // URL to web api

    constructor(private http: Http, public toasterService: ToasterService) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getServiceInvoiceList(query: any): Promise<ServiceInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceInvoiceUrl}/getServiceInvoiceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getServiceInvoiceDetailList(query: any): Promise<ServiceInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceInvoiceUrl}/getServiceInvoiceDetailList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData,
            // Errors will call this callback instead:
            err => {
                var toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'Something went wrong, Please Contact System Admin'
                };
                this.toasterService.pop(toast);
            })
            .catch(this.handleError);
    }

    checkSrf(query: any): Promise<ServiceInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceInvoiceUrl}/checkSrf`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData,
            // Errors will call this callback instead:
            err => {
                var toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'Something went wrong, Please Contact System Admin'
                };
                this.toasterService.pop(toast);
            })
            .catch(this.handleError);
    }

    addServiceInvoice(query: any): Promise<ServiceInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceInvoiceUrl}/addServiceInvoice`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    } 
     getModelDetails(query: any): Promise<ServiceInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceInvoiceUrl}/getModelDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    deleteGridList(rowData: any): Promise<ServiceInvoiceModel> {
        const url = `${this.serviceInvoiceUrl}/deleteGridList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceInvoiceModel)
            .catch(this.handleError);
    }

    deleteServiceInvoiceEntry(rowData: any): Promise<ServiceInvoiceModel> {
        const url = `${this.serviceInvoiceUrl}/deleteServiceInvoiceEntry`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceInvoiceModel)
            .catch(this.handleError);
    }

    addUpdateServiceInvoiceEntry(data: any): Promise<ServiceInvoiceModel> {

        const url = `${this.serviceInvoiceUrl}/addUpdateServiceInvoiceEntry`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceInvoiceModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/serviceInvoice.service.ts